import axios from 'axios';

import { appStorage } from 'utils/appStorage';

import { LOCAL_STORAGE_KEYS } from 'ts/constants/local-storage-keys';

export interface StoreMetaPayload {
  source?: string;
  campaign?: string;
  creative?: string;
  refer_url?: string;
}

const apiHost = process.env.REACT_APP_API_URL;

export const saveLocalUserMeta = () => {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());
  const data: StoreMetaPayload = {};

  if (params['utm_source']) {
    data.source = params['utm_source'];
  }

  if (params['utm_campaign']) {
    data.campaign = params['utm_campaign'];
  }

  if (params['creative']) {
    data.creative = params['creative'];
  }

  if (params['refer_url']) {
    data.refer_url = params['refer_url'];
  }

  if (Object.keys(data).length > 0) {
    appStorage.setItem(LOCAL_STORAGE_KEYS.USER_META, JSON.stringify(data));
  }
};

export const updateUserMeta = async (): Promise<void> => {
  const metaValue = appStorage.getItem(LOCAL_STORAGE_KEYS.USER_META);
  const isStored = appStorage.getItem(LOCAL_STORAGE_KEYS.IS_USER_META_STORED);

  if (!metaValue || isStored) return;

  await axios.post(`${apiHost}/user/meta`, JSON.parse(metaValue));
  appStorage.setItem(LOCAL_STORAGE_KEYS.IS_USER_META_STORED, 'true');
  appStorage.removeItem(LOCAL_STORAGE_KEYS.USER_META);
};
